import { render, staticRenderFns } from "./PayUToC.vue?vue&type=template&id=f7567dd0&scoped=true&"
import script from "./PayUToC.vue?vue&type=script&lang=js&"
export * from "./PayUToC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7567dd0",
  null
  
)

export default component.exports